import { defineRoute } from "src/routing/defineRoute";
import { developmentRoute } from "src/routing/domains/developments/detail/developmentDetailPaths";

/**
 * Path + typed URL builder pairs for development product-offering routes.
 *
 * Kept separate from the route tree so `RouteUrls.ts` and pages can import paths without a cycle
 * through page `Component` imports.
 *
 * Optional `:rpavId?` keeps a legacy plain path string for matching (same as projects).
 */
export const developmentProductOfferingsRoute = defineRoute(`${developmentRoute.path}/product-offerings`);
/** Optional params keep the legacy `?` path string for matching. */
export const developmentProductOfferingOptionalPath = `${developmentRoute.path}/product-offerings/:productOfferingId/:rpavId?`;
export const developmentProductOfferingApplyToProjectRoute = defineRoute(
  `${developmentRoute.path}/product-offerings/:productOfferingId/:rpavId/apply`,
);
export const developmentProductOfferingVersionHistoryRoute = defineRoute(
  `${developmentRoute.path}/product-offerings/:productOfferingId/history`,
);
export const developmentProductOfferingSpecificConfigsRoute = defineRoute(
  `${developmentRoute.path}/product-offerings/:productOfferingId/product-offering-configs`,
);
export const developmentProductOfferingConfigsRoute = defineRoute(`${developmentRoute.path}/product-offering-configs`);
export const developmentProductOfferingSpecificConfigsCompareRoute = defineRoute(
  `${developmentRoute.path}/product-offering-configs/:productOfferingId/compare`,
);
export const developmentProductOfferingConfigsCompareRoute = defineRoute(
  `${developmentRoute.path}/product-offering-configs/compare`,
);
